import React from "react";

function Regular() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 64 64"
    >
      <path
        fill="#0a5078"
        d="M44 60H12a4 4 0 01-4-4V12a4 4 0 014-4h32a4 4 0 014 4v44a4 4 0 01-4 4z"
        data-original="#0a5078"
      ></path>
      <path
        fill="#00325a"
        d="M36 36c0 6.627 5.373 12 12 12V24c-6.627 0-12 5.373-12 12z"
        data-original="#00325a"
      ></path>
      <path
        fill="#00325a"
        d="M44 59H12a2 2 0 01-2-2V13a2 2 0 012-2h32a2 2 0 012 2v44a2 2 0 01-2 2z"
        data-original="#00325a"
      ></path>
      <path
        fill="#f0f0f0"
        d="M44 58H12a2 2 0 01-2-2V12a2 2 0 012-2h32a2 2 0 012 2v44a2 2 0 01-2 2z"
        data-original="#f0f0f0"
      ></path>
      <path
        fill="#d2d2d2"
        d="M46 24.167c-5.675.952-10 5.887-10 11.833s4.325 10.881 10 11.833zM34 9V8a3 3 0 00-3-3h-6a3 3 0 00-3 3v1h-2a2 2 0 00-2 2v2a2 2 0 002 2h16a2 2 0 002-2v-2a2 2 0 00-2-2z"
        data-original="#d2d2d2"
      ></path>
      <path
        fill="#fab400"
        d="M34 8V7a3 3 0 00-3-3h-6a3 3 0 00-3 3v1h-2a2 2 0 00-2 2v2a2 2 0 002 2h16a2 2 0 002-2v-2a2 2 0 00-2-2z"
        data-original="#fab400"
      ></path>
      <circle
        cx="21"
        cy="11"
        r="1"
        fill="#be7800"
        data-original="#be7800"
      ></circle>
      <circle
        cx="35"
        cy="11"
        r="1"
        fill="#be7800"
        data-original="#be7800"
      ></circle>
      <circle
        cx="18"
        cy="20"
        r="4"
        fill="#d2d2d2"
        data-original="#d2d2d2"
      ></circle>
      <path
        fill="#d2d2d2"
        d="M41 21H25a1 1 0 010-2h16a1 1 0 010 2z"
        data-original="#d2d2d2"
      ></path>
      <circle
        cx="18"
        cy="30"
        r="4"
        fill="#d2d2d2"
        data-original="#d2d2d2"
      ></circle>
      <path
        fill="#d2d2d2"
        d="M41 31H25a1 1 0 010-2h16a1 1 0 010 2z"
        data-original="#d2d2d2"
      ></path>
      <circle
        cx="18"
        cy="40"
        r="4"
        fill="#d2d2d2"
        data-original="#d2d2d2"
      ></circle>
      <path
        fill="#d2d2d2"
        d="M41 41H25a1 1 0 010-2h16a1 1 0 010 2z"
        data-original="#d2d2d2"
      ></path>
      <circle
        cx="18"
        cy="50"
        r="4"
        fill="#d2d2d2"
        data-original="#d2d2d2"
      ></circle>
      <path
        fill="#d2d2d2"
        d="M41 51H25a1 1 0 010-2h16a1 1 0 010 2z"
        data-original="#d2d2d2"
      ></path>
      <circle
        cx="48"
        cy="35"
        r="12"
        fill="#c80a50"
        data-original="#c80a50"
      ></circle>
      <circle
        cx="48"
        cy="35"
        r="10"
        fill="#f0f0f0"
        data-original="#f0f0f0"
      ></circle>
      <path
        fill="#0a5078"
        d="M54 34h-5v-5a1 1 0 00-2 0v6a1 1 0 001 1h6a1 1 0 000-2z"
        data-original="#0a5078"
      ></path>
      <circle
        cx="48"
        cy="35"
        r="2"
        fill="#c80a50"
        data-original="#c80a50"
      ></circle>
      <path
        fill="#00a0c8"
        d="M48 25c-.338 0-.671.017-1 .05V26a1 1 0 002 0v-.95c-.329-.033-.662-.05-1-.05zm0 18a1 1 0 00-1 1v.95a10.008 10.008 0 002 0V44a1 1 0 00-1-1zm-9.95-7H39a1 1 0 000-2h-.95a10.008 10.008 0 000 2zM56 35a1 1 0 001 1h.95a10.008 10.008 0 000-2H57a1 1 0 00-1 1z"
        data-original="#00a0c8"
      ></path>
      <path
        fill="#c80a50"
        d="M18 22a.997.997 0 01-.707-.293l-2-2a.999.999 0 111.414-1.414L18 19.586l3.293-3.293a.999.999 0 111.414 1.414l-4 4A.997.997 0 0118 22zm0 10a.997.997 0 01-.707-.293l-2-2a.999.999 0 111.414-1.414L18 29.586l3.293-3.293a.999.999 0 111.414 1.414l-4 4A.997.997 0 0118 32zm0 10a.997.997 0 01-.707-.293l-2-2a.999.999 0 111.414-1.414L18 39.586l3.293-3.293a.999.999 0 111.414 1.414l-4 4A.997.997 0 0118 42z"
        data-original="#c80a50"
      ></path>
    </svg>
  );
}

export default Regular;